import apiClient from "./api";
import { getApiAccessToken } from "./UserService";

export interface ContractPriceGroupsContractOption {
  id: number;
  name: string;
}

export interface ContractPriceItem {
  generalPriceItemId: number;
  priceItemId?: number | null;
  itemNumber: number;
  itemSubnumber: number;
  itemCode?: string | null;
  name: string;
  unitName: string;
  unitPrice?: number | null;
  selected: boolean;
  showAltValueField: boolean;
  isInUse: boolean;
}

export interface ContractPriceGroup {
  id: number;
  name: string;
  orderInGroup: number;
  rowNumber: number;
  isActive: boolean;
  items: ContractPriceItem[];
}

export interface ContractPriceGroupsResponse {
  hideWorkItemNumber: boolean;
  useWorkItemCode: boolean;
  showWorkItemAreaPerPriceItem: boolean;
  selectedContractId?: number | null;
  generalPriceGroupOrder: number;
  hasAnyPriceItems: boolean;
  availableContracts: ContractPriceGroupsContractOption[];
  groups: ContractPriceGroup[];
}

export interface SaveContractPriceGroupsRequest {
  generalPriceGroupOrder: number;
  items: ContractPriceItemSelectionRequest[];
}

export interface ContractPriceItemSelectionRequest {
  generalPriceItemId: number;
  unitPrice?: number | null;
  selected: boolean;
  showAltValueField: boolean;
}

async function authHeader(): Promise<Record<string, string>> {
  const token = await getApiAccessToken();
  return { Authorization: `Bearer ${token}` };
}

export const getContractPriceGroups = async (
  addressSystemId: number,
  contractId?: number | null,
): Promise<ContractPriceGroupsResponse> => {
  const headers = await authHeader();
  const response = await apiClient.get<ContractPriceGroupsResponse>(
    `/api/ContractPriceGroups/${addressSystemId}`,
    {
      headers,
      params: contractId ? { contractId } : undefined,
    },
  );
  return response.data;
};

export const saveContractPriceGroups = async (
  addressSystemId: number,
  contractId: number,
  request: SaveContractPriceGroupsRequest,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.put(
    `/api/ContractPriceGroups/${addressSystemId}/contracts/${contractId}`,
    request,
    { headers },
  );
};

export const copyContractPriceGroups = async (
  addressSystemId: number,
  contractId: number,
  sourceContractId: number,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.post(
    `/api/ContractPriceGroups/${addressSystemId}/contracts/${contractId}/copy`,
    { sourceContractId },
    { headers },
  );
};

export const moveContractPriceGroup = async (
  addressSystemId: number,
  contractId: number,
  groupId: number,
  direction: -1 | 1,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.post(
    `/api/ContractPriceGroups/${addressSystemId}/contracts/${contractId}/groups/${groupId}/move`,
    { direction },
    { headers },
  );
};